import { isPermissionError } from "@/lib/is-permission-error";

/**
 * A project-scoped work-item panel load (sub-items, relations, attachments) that
 * fails is one of two states: a **403** the caller genuinely lacks permission
 * for — a "you don't have access" state, i.e. expected degradation for a user
 * who can open the work item (workspace.read) but not its project-scoped
 * sub-resources (workitem.read) — or **any other** failure that warrants a
 * retry-style error. Stores keep this discriminant in their `errorByIssueId`
 * map so the panel renders the right branch instead of a generic "Failed to
 * load" that masks the permission case (and reads as a bug to the user).
 */
export type PanelFetchError = "forbidden" | "generic";

/** Map a caught panel-fetch error to its state: HTTP 403 → forbidden, else generic. */
export function classifyPanelFetchError(error: unknown): PanelFetchError {
  return isPermissionError(error) ? "forbidden" : "generic";
}
